export const REQUEST_INPUT_RECORDINGS = 'REQUEST_INPUT_RECORDINGS'
export const LOAD_INPUT_RECORDINGS = 'LOAD_INPUT_RECORDINGS'
export const ADD_INPUT_RECORDINGS = 'ADD_INPUT_RECORDINGS'
export const DELETE_INPUT_RECORDINGS = 'DELETE_INPUT_RECORDINGS'

export const REQUEST_DB_RECORDINGS = 'REQUEST_DB_RECORDINGS'
export const LOAD_DB_RECORDINGS = 'LOAD_DB_RECORDINGS'
export const ADD_DB_RECORDINGS = 'ADD_DB_RECORDINGS'
export const DELETE_DB_RECORDINGS = 'DELETE_DB_RECORDINGS'

export const REQUEST_MATCH_RECORDINGS = 'REQUEST_MATCH_RECORDINGS'
export const LOAD_MATCH_RECORDINGS = 'LOAD_MATCH_RECORDINGS'
export const ADD_MATCH_RECORDINGS = 'ADD_MATCH_RECORDINGS'
export const DELETE_MATCH_RECORDINGS = 'DELETE_MATCH_RECORDINGS'

export const MATCH_RECORDING = "MATCH_RECORDING"
export const UNMATCH_RECORDING = "UNMATCH_RECORDING"
export const SEARCH_RECORDING = "SEARCH_RECORDING"
export const SELECT_RECORDING = "SELECT_RECORDING"

export default {
    REQUEST_INPUT_RECORDINGS,
    REQUEST_MATCH_RECORDINGS,
    REQUEST_DB_RECORDINGS,
    LOAD_INPUT_RECORDINGS,
    LOAD_MATCH_RECORDINGS,
    LOAD_DB_RECORDINGS,
    ADD_INPUT_RECORDINGS,
    ADD_MATCH_RECORDINGS,
    ADD_DB_RECORDINGS,
    DELETE_INPUT_RECORDINGS,
    DELETE_MATCH_RECORDINGS,
    DELETE_DB_RECORDINGS,
    SEARCH_RECORDING,
    MATCH_RECORDING,
    UNMATCH_RECORDING,
    SELECT_RECORDING
}
